import { makeStyles, tokens, shorthands, typographyStyles } from '@fluentui/react-components';

export const useCompanyPageSelectionStageStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingVerticalXXXL),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingVerticalXXXL),
  },
  descriptionContainer: {
    alignSelf: 'flex-start',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '32px',
    color: tokens.colorNeutralForeground1,
    textAlign: 'center',
    marginBottom: '4px',
    marginTop: '0px',
  },
  itemText: {
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground2,
    textAlign: 'center',
  },
  companyPageContainer: {
    width: '100%',
  },
  selectedCompanyPageContainer: {
    display: 'flex',
    width: '100%',
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
  },
  companyPageInfo: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    marginLeft: '12px',
    marginRight: '12px',
    marginTop: '8px',
    marginBottom: '8px',
  },
  companyPageActions: {
    display: 'flex',
    '& .choose-again-button': {
      color: tokens.colorNeutralForeground3BrandHover,
    },
  },
  selectionContainer: {
    alignSelf: 'flex-start',
    width: '100%',
  },
  selector: {
    width: '100%',
  },
  info: {
    display: 'flex',
    maxWidth: '460px',
    marginTop: '8px',
    marginBottom: '24px',
    fontSize: tokens.fontSizeBase200,
  },
  infoIcon: {
    marginRight: '4px',
  },
  helpLink: {
    marginLeft: '4px',
  },
  actionsContainer: {
    display: 'flex',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
  termsAndConditions: {
    maxWidth: '460px',

    '& label.fui-Label': {
      ...typographyStyles.caption1,
      ...shorthands.padding(0),
    },
  },
});
